import React, { Component } from "react";
import PropTypes from "prop-types";
import constants from "../../utils/constants";

function evalScript(scriptArr) {
  const elem = scriptArr.shift();
  const head = document.getElementsByTagName("head")[0] || document.documentElement;
  const script = document.createElement("script");

  if (elem && elem.src) {
    script.type = "text/javascript";
    script.src = elem.src;

    if (scriptArr.length > 0) {
      let done = false;
      script.onload = script.onreadystatechange = function () {
        // eslint-disable-line
        console.log("------------------ LOADED ------------------");
        if (
          !done &&
          (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")
        ) {
          done = true;
          evalScript(scriptArr);
          script.onload = script.onreadystatechange = null;
        }
      };
    }

    head.insertBefore(script, head.firstChild);
    return null;
  }

  const data = elem.text || elem.textContent || elem.innerHTML || "";
  script.type = "text/javascript";
  script.appendChild(
    //Wrapping the script itself in try/catch will silence most errors. It will still get printed.
    document.createTextNode(`try { ${data} } catch(e) { console.error("MARKUP ERROR", e); }`)
  );
  head.insertBefore(script, head.firstChild);
  try {
    head.removeChild(script);
    if (elem.parentNode) {
      elem.parentNode.removeChild(elem);
    }
  } catch (e) {
    console.warn("Failed to remove child", e);
  }
  if (scriptArr.length > 0) {
    evalScript(scriptArr);
  }
}

function nodeName(elem, name) {
  return elem.nodeName && elem.nodeName.toUpperCase() === name.toUpperCase();
}

function insertAndExecute(domElement, text, externalReservation, externalConfiguration) {
  let parsedText = text;
  if (externalReservation) {
    parsedText = parsedText
      .replace(
        new RegExp(constants.MARKUP_TAG.PROPERTY_TICKER, "g"),
        externalConfiguration.establishment
      )
      .replace(new RegExp(constants.MARKUP_TAG.AMOUNT, "g"), externalReservation.amount)
      .replace(new RegExp(constants.MARKUP_TAG.RESERVATION_ID, "g"), externalReservation.id)
      .replace(
        new RegExp(constants.MARKUP_TAG.LANGUAGE, "g"),
        externalConfiguration.defaultLanguage
      )
      .replace(
        new RegExp(constants.MARKUP_TAG.CURRENCY, "g"),
        externalConfiguration.defaultCurrency
      )
      .replace(
        new RegExp(constants.MARKUP_TAG.CHECK_IN, "g"),
        externalReservation.items && externalReservation.items[0].checkIn
      )
      .replace(
        new RegExp(constants.MARKUP_TAG.CHECK_OUT, "g"),
        externalReservation.items && externalReservation.items[0].checkOut
      );
  }
  domElement.innerHTML += parsedText;
  const scripts = [];

  const ret = domElement.childNodes;
  for (let idx = 0; ret[idx]; idx++) {
    if (
      scripts &&
      nodeName(ret[idx], "script") &&
      (!ret[idx].type || ret[idx].type.toLowerCase() === "text/javascript")
    ) {
      scripts.push(ret[idx].parentNode ? ret[idx].parentNode.removeChild(ret[idx]) : ret[idx]);
    }
  }

  if (scripts.length > 0) {
    evalScript(scripts);
  }
}

class ExternalMarkup extends Component {
  constructor(props) {
    super(props);
    this.execute = this.execute.bind(this);
    // We use an instance variable because there's ONLY one instance of ExternalMarkup in the app (like a singleton)
    this.executed = [];
    this.phaseAllExecuted = {};
  }

  componentDidMount() {
    window.transactionObject = this.props.externalReservation;
    window.configuration = this.props.externalConfiguration;

    if (this.props.markups) {
      this.execute(this.props.markups, this.props.currentStep);
    }

    if (!this.props.isLoaded) {
      this.props.loaded();
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.markups !== this.props.markups;
  }

  componentWillUpdate(nextProps) {
    window.transactionObject = nextProps.externalReservation;
    window.configuration = nextProps.externalConfiguration;

    if (this.props.markups !== nextProps.markups) {
      this.execute(nextProps.markups, nextProps.currentStep);
    }

    if (!nextProps.isLoaded) {
      nextProps.loaded();
    }
  }

  execute(markups, currentStep) {
    if (markups) {
      markups.forEach(markup => {
        if (this.executed.indexOf(markup.get("id")) === -1) {
          if (markup.get("phase") === constants.MARKUP_PHASE.STEP_3 && markup.get("oneTime")) {
            if (
              this.props.reservationCreated &&
              this.props.externalReservation &&
              this.props.externalReservation.status === constants.RESERVATION_STATUS.CONFIRMED
            ) {
              insertAndExecute(
                this.refs.markupContainer,
                markup.get("code"),
                this.props.externalReservation,
                this.props.externalConfiguration
              );
              this.executed.push(markup.get("id"));
            }
          } else {
            if (markup.get("phase") === constants.MARKUP_PHASE.ALL) {
              if (!this.phaseAllExecuted[currentStep]) {
                this.phaseAllExecuted[currentStep] = [];
              }
              if (this.phaseAllExecuted[currentStep].indexOf(markup.get("id")) === -1) {
                insertAndExecute(
                  this.refs.markupContainer,
                  markup.get("code"),
                  this.props.externalReservation,
                  this.props.externalConfiguration
                );
                this.phaseAllExecuted[currentStep].push(markup.get("id"));
              }

              if (markup.get("oneTime")) {
                this.executed.push(markup.get("id"));
              }
            } else {
              insertAndExecute(
                this.refs.markupContainer,
                markup.get("code"),
                this.props.externalReservation,
                this.props.externalConfiguration
              );
              this.executed.push(markup.get("id"));
            }
          }
        }
      });
    }
  }

  render() {
    return <div ref="markupContainer"></div>;
  }
}

ExternalMarkup.propTypes = {
  markups: PropTypes.array.isRequired,
  reservationCreated: PropTypes.bool,
  currentStep: PropTypes.string,
  externalConfiguration: PropTypes.object,
  externalReservation: PropTypes.object,
  loaded: PropTypes.func,
  isLoaded: PropTypes.bool,
};

export default ExternalMarkup;
